import React from "react";
import {LLElementTypeSetter} from "../../../../components";

const MatchDetailsTitle = ({ match, }) => (
    <div className="match-details__title">
        <div className="match-details__links-wrp">
            <LLElementTypeSetter as="NavLink" to={match.categoryUrl()}>
                {match.nameOf('category')}
            </LLElementTypeSetter>
            <LLElementTypeSetter as="NavLink" to={match.tournamentUrl()}>
                {match.nameOf('tournament')}
            </LLElementTypeSetter>
        </div>
    </div>
);

export default MatchDetailsTitle;
